const RESIDENCE_TYPE = {
  project: 10,
  community: 20,
  student: 30,
  garden: 40,
  office: 50,
};
export default RESIDENCE_TYPE;
